import React from 'react';
import { Box } from '@mui/material';
import Button from '../../../components/Button';
import SearchBox from '../../../components/SearchBox';
import AddIcon from '@mui/icons-material/Add';
import Star from '@mui/icons-material/Star';
import useStore from '../../../Store/Store';

const TopBar = ({ btnText = 'Add Diagnosis', onClick, onChange }) => {
  const features = useStore((state) => state.features);
  return (
    <Box
      display="flex"
      width="100%"
      alignItems="center"
      justifyContent="space-between"
      position="relative"
      padding="0 16px"
      sx={{
        '@media (max-width: 768px)': {
          flexDirection: 'column',
          alignItems: 'stretch',
        },
      }}
    >
      <div>
        {features.crSearchbar && (btnText === 'Add Diagnosis' || btnText === 'Add Allergy') && (
          <SearchBox onChange={onChange} />
        )}
        {btnText === 'Add Medication' && (
          <Button startIcon={<Star />} text={'Medication intake statistics'} bg="light" onClick={onClick} />
        )}
      </div>

      <Box display="flex" alignItems="center" gap={3}>
        <Button startIcon={<AddIcon />} text={btnText} onClick={onClick} />
      </Box>
    </Box>
  );
};

export default TopBar;
